import { render } from "./FormularioBaseEmpresa.vue?vue&type=template&id=25454f8d&scoped=true"
import script from "./FormularioBaseEmpresa.vue?vue&type=script&lang=js"
export * from "./FormularioBaseEmpresa.vue?vue&type=script&lang=js"

import "./FormularioBaseEmpresa.vue?vue&type=style&index=0&id=25454f8d&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25454f8d"],['__file',"src/views/Legalize/CadastroDeProcessos/Components/FormularioBaseEmpresa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25454f8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25454f8d', __exports__)) {
    console.log('reload')
    api.reload('25454f8d', __exports__)
  }
  
  module.hot.accept("./FormularioBaseEmpresa.vue?vue&type=template&id=25454f8d&scoped=true", () => {
    console.log('re-render')
    api.rerender('25454f8d', render)
  })

}


export default __exports__